<template>
    <div class="task-list-page-list">
        <div
            v-for="(item, index) in data"
            :key="index"
            class="task-list-item"
            @click="handleClick(item)"
        >
            <p class="task-title">{{ item.title || "未命名" }}</p>
            <div class="task-sub-info">
                <span>发起人: {{ item.userName }}</span>
                <span>发起时间: {{ item.dateTime }}</span>
            </div>
            <div class="task-tags">
                <span class="tag tag-primary">{{ getStatusText(item) }}</span>
                <span class="tag tag-secondary">{{ getTypeText(item.type) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    const {
        getStatusText,
        getTypeText,
    } = require(`@/config/${process.env.VUE_APP_PROJECT}/taskList`)
    export default {
        name: 'TaskListItem',
        props: {
            data: {
                type: Array,
                default: () => [],
            },
        },
        methods: {
            getStatusText(item) {
                return getStatusText(item)
            },
            getTypeText(type) {
                return getTypeText(type)
            },
            handleClick(item) {
                this.$emit('handleClick', item)
            },
        },
    }
</script>

<style lang="scss">
.task-list-page-list {
  padding: 0 10px;
  background: #fff;

  .task-list-item {
    position: relative;
    padding: 15px 10px;
    cursor: pointer;
    .task-title {
      font-size: 16px;
      font-weight: bold;
      color: #000;
      margin: 0;
      line-height: 1.4;
    }
    .task-sub-info {
      padding-left: 2px;
      margin-top: 10px;
      color: #595959;
      font-size: 14px;
      span {
        margin-right: 10px;
      }
    }
    .task-tags {
      margin-top: 12px;
      .tag {
        display: inline-block;
        padding: 2px 8px;
        border-radius: 3px;
        margin-right: 8px;
        font-size: 12px;
      }
      .tag-primary {
        border: 1px solid #41c39e;
        color: #41c39e;
      }
      .tag-secondary {
        border: 1px solid #d4a854;
        color: #d4a854;
      }
    }
  }
  .task-list-item:not(:last-of-type) {
    border-bottom: 1px dashed #cccccc;
  }
}
</style>
